module.exports = __webpack_public_path__ + "img/vertical_3_4_9005.843c452d.png";